"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const monaco = __importStar(require("monaco-editor"));
const React = __importStar(require("react"));
const Card_1 = require("./Card");
const cellify_1 = require("./cellify");
const element_scss_1 = __importDefault(require("./styles/element.scss"));
const monaco_flexible_1 = require("./monaco-flexible");
function TextCell({ id, nodes, onUpdate }) {
    const [html, setHtml] = React.useState(() => cellify_1.htmlify(nodes));
    const [md, setMd] = React.useState(() => cellify_1.markdownify(nodes));
    const [editable, setEditable] = React.useState(false);
    const rootRef = React.useRef(null);
    React.useEffect(() => {
        if (!rootRef.current || !editable)
            return;
        const editor = monaco.editor.create(rootRef.current, {
            language: 'markdown',
            value: md
        });
        monaco_flexible_1.beFlexible(editor);
        editor.onDidBlurEditorText(() => {
            const value = editor.getValue();
            setMd(value);
            onUpdate({ id, value }); // TODO: id is changable
            setHtml(cellify_1.md2html(value));
            setEditable(false);
        });
        editor.focus();
        return () => {
            editor.dispose();
        };
    }, [editable]);
    return (React.createElement(Card_1.Card, { elevated: editable, className: element_scss_1.default.textCell },
        React.createElement("div", { dangerouslySetInnerHTML: editable ? undefined : html, onClick: () => setEditable(true) }),
        React.createElement("div", { ref: rootRef, style: { height: editable ? monaco_flexible_1.getInitialHeight(md) : 0 } })));
}
exports.TextCell = TextCell;
